import DeleteIcon from '@mui/icons-material/Delete';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { Tooltip } from '../../../../components/Tooltip';
import { CreateVoucherDrawer } from '../CreateVoucherDrawer/CreateVoucherDrawer';
import { DeleteVoucherDialog } from '../DeleteVoucherDialog/DeleteVoucherDialog';
import { useVouchersDrawer } from './useVouchersDrawer';

interface VouchersDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  eventId: string | null;
}

export const VouchersDrawer: FunctionComponent<VouchersDrawerProps> = ({
  isOpen,
  onClose,
  eventId,
}) => {
  const {
    vouchers,
    onCreateVoucher,
    isCreateVoucherDrawerOpen,
    onCreateVoucherDrawerClose,
    loading,
    onDeleteVoucher,
    onShowDeleteDialog,
    onCloseDeleteDialog,
    voucherToDeleteId,
  } = useVouchersDrawer(eventId);

  return (
    <>
      <Drawer anchor="right" open={isOpen} onClose={onClose}>
        <Box sx={{ mt: 10, mx: 2, width: 360 }}>
          <Typography variant="h4">
            {"Codes de réductions de l'événement"}
          </Typography>
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {vouchers.map((voucher) => (
              <div key={voucher.id}>
                <ListItem
                  alignItems="flex-start"
                  secondaryAction={
                    <Tooltip title="Supprimer le code">
                      <IconButton
                        color="error"
                        onClick={() => onShowDeleteDialog(voucher.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  }
                >
                  <ListItemText
                    primary={voucher.code}
                    secondary={
                      <Box flexDirection="column" display="flex">
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ color: 'text.primary', display: 'inline' }}
                        >
                          Réduction de {voucher.amount / 100}€
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
                <Divider component="li" />
              </div>
            ))}
            <Box display="flex" justifyContent="center" marginBottom={1}>
              {loading ? <CircularProgress /> : null}
            </Box>
          </List>
          <Button variant="outlined" fullWidth onClick={onCreateVoucher}>
            Ajouter un code de réduction
          </Button>
        </Box>
      </Drawer>
      {isCreateVoucherDrawerOpen ? (
        <CreateVoucherDrawer
          eventId={eventId}
          isOpen={isCreateVoucherDrawerOpen}
          onClose={onCreateVoucherDrawerClose}
        />
      ) : null}
      <DeleteVoucherDialog
        onCancel={onCloseDeleteDialog}
        onDelete={onDeleteVoucher}
        open={voucherToDeleteId !== null}
      />
    </>
  );
};
